import { useEffect, useRef } from 'react';
import { useAppSelector } from '../hooks';
import { saveAppSettings } from '../utils/NativeWebView';

const useCheckSettings = () => {

  const checked = useRef(false);
  const { loading, locations } = useAppSelector( state => state.webSettings );

  useEffect(() => {
    if (loading && !checked.current) {
      checked.current = true;

      //check only if appSettings exist
      if (!window.appSettings || window.appSettings.status !== 'ok') {
        // consoleLog('app is not set');
        return;
      }
      if (window.appSettings.branch === 'other') return;

      const branchLatLong = window.appSettings.branchLatLong;
      // consoleLog(JSON.stringify(window.appSettings));
      if (!branchLatLong || branchLatLong === '' ) {
        const appType = window.appSettings.appType;
        const branch = window.appSettings.branch;
        const user = window.appSettings.user;

        const branchData = locations.find(location => String(location.id) === branch);
        const branchName = branchData ? branchData.name : '';
        const branchLatLong = branchData ? `${branchData.lat}, ${branchData.long}` : '';

        window.appSettings.branchLatLong = branchLatLong;
        window.appSettings.branchName = branchName;

        // consoleLog(`Set New lat_long: ${branchLatLong}`);
        // update app settings on mobile app - save on storage
        saveAppSettings({ appType, user, branch, branchName, branchLatLong });
      }

    }
  }, [locations, loading]);

  return;

};

export default useCheckSettings;
